export default "__VITE_ASSET__ZGgoXDF1__"